import {
  FocusGroupsService,
  type FocusGroupResponseDto,
} from '@inference.engine/persona-api-client';
import { personasHttp } from '@/lib/api/personas-client';
import { downloadPdfBlob } from '@/shared/api/pdf-download.api';

/**
 * Fetch a focus group for the `/download/focus-group/:id` print page. persona-api
 * scopes by workspace and the headless render has no store, so the workspace
 * (from the print page's `?workspaceId=`) is passed as the header explicitly.
 */
export const getFocusGroupForDownload = async (
  workspaceId: string,
  id: string,
): Promise<FocusGroupResponseDto> => {
  const response = await FocusGroupsService.getById({
    client: personasHttp,
    path: { id },
    headers: { 'x-selected-workspace-id': workspaceId },
    throwOnError: true,
  });
  return response.data;
};

export type FocusGroupPdfSection = 'summary' | 'interviews';

/** Download one section of a focus group as a server-rendered PDF blob. */
export const downloadFocusGroupPdf = (
  id: string,
  workspaceId: string,
  section: FocusGroupPdfSection,
): Promise<Blob> =>
  downloadPdfBlob('focus-groups', id, {
    // eslint-disable-next-line i18next/no-literal-string -- interpolated into the diagnostic `pdf-download.api.ts` throws; the caller toasts its own translated message
    label: 'Focus group',
    params: { workspaceId, section },
  });
